export const adicionarAvatar = () => ({
  type: "ADICIONAR_AVATAR",
});

export const removerAvatar = (index) => ({
  type: "REMOVER_AVATAR",
  payload: index,
});

export const atualizarAvatar = (index, campo, valor) => ({
  type: "ATUALIZAR_AVATAR",
  payload: { index, campo, valor },
});

export const posicionarAvatar = (index, x, y) => ({
  type: "POSICIONAR_AVATAR",
  payload: { index, x, y },
});

export const toggleVisibilidadeAvatar = (index, visivel) => ({
  type: "TOGGLE_VISIBILIDADE_AVATAR",
  payload: { index, visivel },
});

export const setAvatars = (avatars) => ({
  type: "SET_AVATARS",
  payload: avatars,
});

// Ações especiais para execução (ignoram travamento)
export const posicionarAvatarExecucao = (index, x, y) => ({
  type: "POSICIONAR_AVATAR_EXECUCAO",
  payload: { index, x, y },
});

export const toggleVisibilidadeAvatarExecucao = (index, visivel) => ({
  type: "TOGGLE_VISIBILIDADE_AVATAR_EXECUCAO",
  payload: { index, visivel },
});

export const restaurarAvatarsExecucao = (avatarsOriginais) => ({
  type: "RESTAURAR_AVATARS_EXECUCAO",
  payload: avatarsOriginais,
});
